import React from 'react'
import { IconVariant, SupplierIcon } from 'components/supplier_shared/supplier_icon'
import OneClickReview from '../supplier_shared/OneClickReview/OneClickReview'

const ReviewOneClickRatingArea = ({ supplier: { id, logoUrl, name } }) => {
  return (
    <>
      <div className='cell small-12 medium-6 padding-2 rating-cta'>
        <div className='grid-x grid-margin-x align-middle'>
          <div className='cell shrink'>
            <SupplierIcon variant={IconVariant.XLARGE} id={id} name={name} logoUrl={logoUrl} />
          </div>
          <div className='cell auto'>
            <p className='color-pro-steel-grey-600 pro-bold word-wrap'>What overall rating would you give <span className='color-pro-blue-400'>{name}</span>?</p>
          </div>
        </div>
      </div>
      <div className='cell small-12 medium-6 padding-2 start-review'>
        <OneClickReview supplierId={id} />
        <p className='color-pro-blue-500 pro-text-m text-center word-wrap'>Start your review of {name}</p>
      </div>
    </>
  )
}

export default ReviewOneClickRatingArea
